import { PersonaDetalle } from "@/pages/persons/schema/person.schema";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import "./text-elements.css";

interface Props {
  personData?: PersonaDetalle | null;
}

export const PersonMainDataCard = ({ personData }: Props) => {
  if (!personData) return null;
  return (
    <Flex flexDir="column">
      <Text
        paddingTop={{
          base: "0",
          sm: "10px",
          md: "12px",
          lg: "25px",
          xl: "20px",
        }}
        paddingBottom="20px"
        fontSize={{
          base: "15px",
          sm: "15px",
          md: "15px",
          lg: "18px",
          xl: "20px",
        }}
        fontWeight={700}
      >
        {personData?.nombre + " " + personData?.apellido}
      </Text>
      <Grid templateColumns="repeat(4, 1fr)" gap="6">
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">DNI</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.dni ?? "-"}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">CUIL</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.cuit ?? "-"}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">N° de teléfono</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.movil ?? "-"}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">Mail</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.mail ?? "-"}
            </Text>
          </Flex>
        </GridItem>
      </Grid>
    </Flex>
  );
};
